import { motion } from "framer-motion";

export default function PageHero({ image, overline, title, description, children, tall = false }) {
  return (
    <section className={`relative flex items-end overflow-hidden grain ${tall ? "h-[52vh] min-h-[420px]" : "h-[42vh] min-h-[340px]"}`}>
      <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-navydeep/95 via-navy/45 to-navy/20" />
      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-10">
        {overline && (
          <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
                    className="text-xs font-bold tracking-[0.25em] uppercase text-sky-300">
            {overline}
          </motion.p>
        )}
        <motion.h1 initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.08 }}
                   className="mt-2 font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white max-w-3xl">
          {title}
        </motion.h1>
        {description && (
          <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.16 }}
                    className="mt-3 max-w-2xl text-base text-slate-200 leading-relaxed">
            {description}
          </motion.p>
        )}
        {children}
      </div>
    </section>
  );
}
